import { PropType } from 'vue'

export type ArticleLinkParams = { [key: string]: string }

export const SEARCH_PROPS = {
  logSearchEvent: {
    type: Function as unknown as PropType<((query: string) => void) | null>,
    default: null,
  },
} as const

export type SearchResultBody = {
  id: string
  slug: string
  searchableBody: string
  title: string
}

export type SearchResultComputed = {
  id: { value: string }
  slug: { value: string }
  searchableBody: { value: string }
  title: { value: string }
}

export type SearchResult = {
  _highlightResult: SearchResultComputed
  _snippetResult: SearchResultComputed
} & SearchResultBody

export type IndexResult = {
  hits: SearchResult[]
}

export type SearchResponse = {
  results: IndexResult[]
}

export type SearchQuery = {
  indexName: string
  params: {
    analytics: boolean
    'attributes-to-snippet': string[]
    distinct: boolean
    enablePersonalization: boolean
    highlightPostTag: string
    highlightPreTag: string
    hitsPerPage: number
    query: string
  }
}

export type SearchClient = {
  search: (query: SearchQuery[]) => Promise<SearchResponse>
}
